module.exports = __webpack_public_path__ + "static/media/stars.953439a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CourseDetail/stars.svg
// module id = 127
// module chunks = 0